const exportData = {
    api_url: process.env.REACT_APP_API_URL,
    //api_url: "http://211.223.88.86:5050/",
    // file_url: 'http://ew.pnsoft.co.kr:45004/files/' // PNSOFT FILE URL
}

export default exportData;